import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {ProjectStepStateService} from '../project-step-state.service';
import {ProjectDataService} from '../../../../shared/services/project-data.service';
import {TranslocoService} from '@jsverse/transloco';
import {UserContractService} from '../../../../shared/services/user-contract.service';
import {ProjectChapterType, ProjectStepType} from '@frontend/shared';
export type ProjectStepComponentInterface = OnInit;

@Component({
  template: '',
})
export abstract class ProjectBaseStepComponent implements ProjectStepComponentInterface, OnInit {
  protected stepState = inject(ProjectStepStateService);
  protected readonly projectDataService = inject(ProjectDataService);
  protected readonly translocoService = inject(TranslocoService);
  protected readonly userContractService = inject(UserContractService);
  private chapterId?: ProjectChapterType;
  private stepId?: ProjectStepType;
  protected projectId!: number;

  protected readonly isLoadingState = signal(true);

  readonly isCurrentStepLocked = computed(() => {
    if (this.chapterId === undefined || this.stepId === undefined) {
      return false;
    }
    return this.stepState.isStepLocked(this.chapterId, this.stepId);
  });

  readonly stepLockedTooltip = computed(() => {
    if (!this.isCurrentStepLocked()) return undefined;
    return this.translocoService.translate('project.steps.stepLocked');
  });

  readonly hasActiveContract = computed(() => {
    return this.userContractService.hasActiveContract() ?? true;
  });

  protected readonly isButtonDisabled = computed(() => {
    return this.isCurrentStepLocked() || !this.hasActiveContract();
  });

  constructor() {
    this.userContractService.fetchContractStatus();
  }

  ngOnInit() {
    const id = this.projectDataService.getProjectId();
    if (id == null) {
      console.error('No project loaded in ProjectBaseStepComponent');
      return;
    }
    this.projectId = id;
    const activeStep = this.stepState.activeStep();
    if (activeStep) {
      this.chapterId = activeStep.chapterId;
      this.stepId = activeStep.stepId;
    }
  }
}
